

import React, { useEffect, useState } from "react";
import './packages.css';
import { BrowserRouter , Routes, Route, Navigate,useNavigate } from "react-router-dom";

import farmTech2 from "../assets/smart-farm_2.gif"; 

import { getPublicPlans } from '../services/plans/publicPlansService';
// import {toFarsiDigits } 

import Util  from '../components/Util'



// const plans = [
//   {
//     name: 'پایه',
//     price: '۰',
//     currency: 'تومان',
//     description: 'مناسب برای شروع و تست امکانات پایه',
//     features: ['۱ یادآور رایگان', 'پشتیبانی ایمیلی', 'دسترسی محدود'],
//     popular: false,
//   },
//   {
//     name: 'حرفه‌ای',
//     price: '۴۹,۰۰۰',
//     currency: 'تومان / ماه',
//     description: 'پلن کامل با بیشترین امکانات',
//     features: ['یادآور نامحدود', 'اعلان پیامک + تلگرام', 'پشتیبانی کامل'],
//     popular: true,
//   },
//   {
//     name: 'ویژه',
//     price: '۹۹,۰۰۰',
//     currency: 'تومان / ماه',
//     description: 'برای کاربران حرفه‌ای با امکانات سفارشی',
//     features: ['همه امکانات پلن حرفه‌ای', 'یادآوری با واتساپ', 'اولویت پشتیبانی'],
//     popular: false,
//   },
// ];

const SubscriptionPage = () => {


  const [plans, setPlans] = useState([]);
  const [freePlan, setFreePlan] = useState(null);
    const [selectedPlan, setSelectedPlan] = useState(null);
  
  const navigate = useNavigate();


    useEffect( () => {
  
      const resp =  getPublicPlans().then(data=>{
        let list = data.data;

        
          list = list.map((p) => ({
            ...p,
            selectedClass: ' ',
          }))
      


        // const free = list.filter(a=> a.isFreePlan === true)[0]
        // setFreePlan(free)

        // const non_free = list.filter(a=> a.isFreePlan === false)

          setPlans(list)
      });
  
  
    }, []);


    const choosePlan = (plan)=>{
      //selected-plan


     setPlans((prevPlans) =>
      prevPlans.map((p) => ({
        ...p,
        selectedClass: plan._id === p._id ? ' selected-plan ' :' ' ,
      }))
     );

      plan.selectedClass = 'selected-plan' ;

      setSelectedPlan(plan)

      setTimeout(()=>{
        navigate('/payments/invoice?item='+plan._id)
      },300);

    };

  return (
    <div className="subscription-page">
      <h1 className="h3 h1-md h1-lg  title">پلن اشتراک خود را انتخاب کنید</h1>

           <div className='mb-2'>
                   <img src={farmTech2} alt="find your plan" width={256}/>
           </div>

      <div className="plan-cards">
        {plans.map((plan, index) => (
          <div
            key={index}
            className={` plan-card ${plan.popular ? ' popular ' : ' '} ${plan.selectedClass}`}
          >
            {plan.popular && <div className="badge">محبوب‌ترین</div>}
            <h2>{plan.name}</h2>

            <h7 className="h5">{plan.price == 0 ? 'همیشگی' : `${Util.toFarsiDigits(plan.durationDays+'')} روزه` }

            </h7>
           
            <p className="price mt-3">
              {plan.price == 0 ? 'رایگان' :  Util.toFarsiDigits( plan.price+'', true ) }
              <span className="currency"> { plan.price == 0 ?'' : plan.priceUnitLabel}</span>
            </p>
            <p className="description"> {Util.toFarsiDigits(plan.maxReminders+'')} یادآور  </p>
            <ul>
              {plan.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
            <button onClick={()=>choosePlan(plan)}
            className={ plan.price == 0 ? "free-subscribe-btn": "subscribe-btn"}>شروع استفاده</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SubscriptionPage;
